import { CAMADAS, CAMADAS_IDS, TOTAL_DE_CADEIRAS, type CamadaId } from './camadas.js';
import type { Candidato } from './candidato.js';
import type { Centavos } from './dinheiro.js';
import { estaNoFunil, ocupaCadeira, preReservaCadeira } from './etapas.js';

/** Números do topo do cockpit. Calculados no cliente e no servidor pela mesma função. */
export interface ResumoDoPainel {
  candidatosNoFunil: number;
  preReservadas: number;
  ocupadas: number;
  disponiveis: number;
  totalDeCadeiras: number;
  /** Soma do investimento anual das cadeiras ocupadas. */
  receitaContratada: Centavos;
  /** Soma do sinal já pago das cadeiras pré-reservadas. */
  receitaPreReservada: Centavos;
  porCamada: Record<CamadaId, { nome: string; ocupadas: number; total: number }>;
}

export function resumirPainel(candidatos: readonly Candidato[]): ResumoDoPainel {
  const ocupadas = candidatos.filter((c) => ocupaCadeira(c.etapa));
  const preReservadas = candidatos.filter((c) => preReservaCadeira(c.etapa));

  const receitaContratada = ocupadas.reduce((soma, c) => soma + CAMADAS[c.camada].valor, 0);
  const receitaPreReservada = preReservadas.reduce(
    (soma, c) => soma + Math.round((CAMADAS[c.camada].valor * 5) / 100),
    0,
  );

  const porCamada = Object.fromEntries(
    CAMADAS_IDS.map((id) => [
      id,
      {
        nome: CAMADAS[id].nome,
        ocupadas: ocupadas.filter((c) => c.camada === id).length,
        total: CAMADAS[id].cadeiras,
      },
    ]),
  ) as ResumoDoPainel['porCamada'];

  return {
    candidatosNoFunil: candidatos.filter((c) => estaNoFunil(c.etapa)).length,
    preReservadas: preReservadas.length,
    ocupadas: ocupadas.length,
    disponiveis: TOTAL_DE_CADEIRAS - ocupadas.length - preReservadas.length,
    totalDeCadeiras: TOTAL_DE_CADEIRAS,
    receitaContratada,
    receitaPreReservada,
    porCamada,
  };
}
